import { Mutations } from 'vuex-smart-module'
import { MutationTypes } from "../mutations-types"
import UserState from "./state"
import { IUserProfile, defaultProfile } from "./models"

export default class UserMutations extends Mutations<UserState>{
    [MutationTypes.USER_SUCCESS](user:IUserProfile){
        this.state.profile = user
        this.state.loaded = true
    }
    [MutationTypes.USER_ERROR](){
        this.state.loaded = false
    }
    [MutationTypes.USER_LOGOUT](){
        this.state.profile = defaultProfile
        this.state.loaded = false
    }
}